module.exports = __webpack_public_path__ + "static/media/addNewMemberTeam.922413ea.svg";